<!--
 * @Author: vince
 * @Date: 2023-06-12 14:47:13
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-06-14 20:12:59
 * @Description:
-->
<template>
  <div class="college">
    <div class="page">
      <div class="page-name">资源管理</div>
      <div class="catalog-box">
        <div class="catalog-row">
          <div class="catalog-col" v-for="(item, index) in list">
            <div
              class="catalog-card"
              @click="
                $router.push({
                  name: 'resourcesEdit',
                  query: { catalogCode: item.catalogCode }
                })
              "
            >
              <img :src="item.catalogUrl" alt="" />
              <div class="catalog-name">{{ item.catalogName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
    this.$axios
      .get('/share/getCatalogInfo', {
        params: {
          orgCode:
            this.userInfo.teacherSchoolList[0].orgCode ||
            this.userInfo.teacherSchoolList[0].schoolCode,
          menuCode: 'resources'
        }
      })
      .then((res) => {
        this.list = res.data
        setTimeout(() => {}, 500)
      })
  }
}
</script>
<style lang="less">
.catalog-box {
  background: rgba(45, 110, 236, 0.05);
  margin-top: 16px;
  padding: 48px;
  flex: 1;
  overflow: auto;
  box-sizing: border-box;
}

.catalog-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: -48px;
  margin-left: -48px;
  height: 100%;
  // align-items: center;
  // flex-wrap: wrap;

  .catalog-col {
    // width: 33.33%;
    padding-left: 48px;
    padding-top: 48px;
  }

  .catalog-card {
    cursor: pointer;
    transition: all 0.2s linear;
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #979797;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }

    &:hover {
      border: 4px solid #2d6eec;
      transform: scale(1.02);
      filter: drop-shadow(2px 4px 6px black);
    }
  }

  .catalog-name {
    line-height: 3;
    font-size: 35px;
    font-family: pfmd;
    color: #333333;

    letter-spacing: 3px;
    text-align: center;
    background-color: white;
  }
}
</style>



